var map = {
	"./social-1.svg": 3196,
	"./social-2.svg": 3799,
	"./social-3.svg": 1589,
	"./social-4.svg": 9100,
	"./social-5.svg": 445,
	"./social-6.svg": 3402,
	"./social-7.svg": 9824,
	"./social-8.svg": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9354;